import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import NavbarMobile from "../../../components/navbar-mobile/navbar-mobile";
import "./style.css";
import "./colors.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
// import AddPost from "../../../components/Modals/AddPost/AddPost";
import VLibras from "@djpfs/react-vlibras";
import AddPostBottom from "../../../components/Modals/add-post/add-post-bottom";
import AddPost from "../../../components/Modals/add-post/add-post";
import { isWebView, shouldHideMenus } from "../../../utils/platform";
import { useAddPost } from "../../../contexts/AddPostContext";

const Main = () => {
    // console.clear();
    console.log('%cDesenvolvido pelo João Enrique', 'font-size: 30px; color: red;');
    console.log(`%chttps://github.com/JoaoEnrique`, 'font-size: 20px; color: #5bb4ff;');
    console.log(`%chttps://linkedin.com/in/joãoenrique`, 'font-size: 20px; color: #5bb4ff;');
    console.log(`%cPaçoca ${new Date().getFullYear()}`, 'font-size: 30px; color: #5bb4ff;');

    // Estados para os plugins
    const [isAccessibilityEnabled, setIsAccessibilityEnabled] = useState(!!sessionStorage.getItem("accessibilityPlugin"));
    const [isPoundsEnabled, setIsPoundsEnabled] = useState(!!sessionStorage.getItem("poundsPlugin"));
    const { setOpen, open } = useAddPost();
    const hideMenus = shouldHideMenus();
    
    const meta = document.createElement('meta');
    meta.name = 'viewport';
    // meta.content = 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no';
    meta.content = 'width=device-width, initial-scale=1';
    document.head.appendChild(meta);

     // 🔒 Se for WebView, desabilita o zoom
    // if (isWebView()) {
    //     const viewport = document.querySelector('meta[name="viewport"]');
    //     if (viewport) {
    //         viewport.setAttribute('content','width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no');
    //     } else {
    //         const meta = document.createElement('meta');
    //         meta.name = 'viewport';
    //         meta.content = 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no';
    //         document.head.appendChild(meta);
    //     }
    // }

    // useEffect(() => {
    //     const btn = document.querySelectorAll("#open-post-mobile");
    //     if (btn) {
    //         btn.forEach(b => b.addEventListener("click", () => setOpen(true)))
    //     }

    //     return () => {
    //         if (btn) {
    //             btn.forEach(b => b.removeEventListener("click", () => setOpen(true)))
    //         }
    //     };
    // }, [location.key]);

    // useEffect(() => {
    //     const btn = document.querySelector("#close-post-mobile");
    //     if (btn) {
    //         btn.addEventListener("click", () => setOpen(true));
    //     }

    //     return () => {
    //         if (btn) {
    //             btn.removeEventListener("click", () => setOpen(true));
    //         }
    //     };
    // }, [location.key]);


    // useEffect(() => {
    //         const btn = document.querySelectorAll("#open-post-mobile-c");
    //     if (btn) {
    //         btn.forEach(b => b.addEventListener("click", () => setOpen(true)))
    //     }

    //     return () => {
    //         if (btn) {
    //             btn.forEach(b => b.removeEventListener("click", () => setOpen(true)))
    //         }
    //     };
    // }, [location.key]);

    // useEffect(() => {
    //     const btn = document.querySelector("#close-post-mobile");
    //     if (btn) {
    //         btn.addEventListener("click", () => setOpen(true));
    //     }

    //     return () => {
    //         if (btn) {
    //             btn.removeEventListener("click", () => setOpen(true));
    //         }
    //     };
    // }, [location.key]);


    useEffect(() => {
        // Função para monitorar mudanças no sessionStorage
        const handleStorageChange = () => {
            setIsAccessibilityEnabled(!!sessionStorage.getItem("accessibilityPlugin"));
            setIsPoundsEnabled(!!sessionStorage.getItem("poundsPlugin"));
        };

        // Adiciona evento de escuta para mudanças no sessionStorage
        window.addEventListener("storage", handleStorageChange);

        return () => {
            window.removeEventListener("storage", handleStorageChange);
        };
    }, []);

    useEffect(() => {
        if (!isWebView()) {
            document.body.classList.add("not-webview");
        }else{
            document.body.classList.add("is-webview");
        }
      }, []);
    

    return (
        <div>
            {!hideMenus && (window.innerWidth <= 850 ? <AddPostBottom open={open} setOpen={setOpen}/> : <AddPost open={open} setOpen={setOpen}/>)}


            {/* Conteúdo das Páginas Filhas */}
            <main>
                <Outlet />

                {/* Carrega o plugin de acessibilidade apenas se ativado */}
                {isAccessibilityEnabled && (
                    <script async src="https://cdn.userway.org/widget.js" data-account="KZUGb7OX4z"></script>
                )}

                {/* Carrega o VLibras apenas se ativado */}
                {isPoundsEnabled && (
                    <VLibras/>
                )}
            </main>
        </div>
    );
};

export default Main;
